import React from "react";
import { BlogCompMyth } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";

interface BlogCompMythProps {
  blok?: BlogCompMyth & SbBlokData;
}

const BlogCompMythComponent: React.FC<BlogCompMythProps> = ({ blok }) => {
  if (!blok) return null;

  const { myth_title, fact_title, myth_content } = blok;

  return (
    <div className="container" {...storyblokEditable(blok)}>
      <div className="py-4">
        <div className="two-thirds-centered">
          <div className="blog-myth-panel">
            <div className="myth-title">
              <div>MYTH</div>
              {myth_title && (
                <h2 id={myth_title.toLowerCase().replace(/\s+/g, "-")}>
                  {myth_title}
                </h2>
              )}
            </div>
            <div className="fact-title">
              <div>FACT</div>
              {fact_title && <h3>{fact_title}</h3>}
            </div>
            <div className="blog-myth-content">
              {myth_content && (
                <div dangerouslySetInnerHTML={{
                  __html: renderRichText(myth_content)
                    .replace(/<a /g, '<a class="text-decoration-underline text-secondary" target="_blank" ')
                }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCompMythComponent;